import mixitup from 'mixitup';

export default {
  init() {
    (function($) {
      $( document ).ready(function() {
          var mixer = mixitup('.mix-container');
          if(mixer) {
            console.log('mix');
          }

          $('.mix-container').fancybox({
            selector: '.fb-gallery > a',
            loop: true,
          });
      });
    })(jQuery);
  },
  finalize() {
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/gallery.js